import type { SESSION_STORAGE_KEYS } from './../constant/session-storage-keys';
import App from '@app/app';

type StoredEnvelope = {
  value: boolean;
  expiresAt?: number;
};

type SetOptions = {
  ttlMs?: number;
};

export class SessionStorageService {
  private readonly prefix = 'mlt/v1/';

  constructor(private readonly sessionTimeoutAction: any) {
    this.sessionTimeoutAction.register(() => {
      this.clearNamespace();
    });
  }

  get(key: SESSION_STORAGE_KEYS): boolean | null {
    try {
      const raw = sessionStorage.getItem(this.prefix + key);
      if (!raw) return null;

      const env: StoredEnvelope = JSON.parse(raw);

      if (typeof env.value !== 'boolean') return null;

      if (env.expiresAt && Date.now() >= env.expiresAt) {
        sessionStorage.removeItem(this.prefix + key);
        return null;
      }

      return env.value;
    } catch {
      return null;
    }
  }

  set(key: SESSION_STORAGE_KEYS, value: boolean, options?: SetOptions): void {
    const envelope: StoredEnvelope = { value };

    if (options?.ttlMs && options.ttlMs > 0) {
      envelope.expiresAt = Date.now() + options.ttlMs;
    }

    sessionStorage.setItem(this.prefix + key, JSON.stringify(envelope));
  }

  remove(key: SESSION_STORAGE_KEYS): void {
    sessionStorage.removeItem(this.prefix + key);
  }

  clearNamespace(): void {
    Object.keys(sessionStorage)
      .filter((k) => k.startsWith(this.prefix))
      .forEach((k) => sessionStorage.removeItem(k));
  }
}

App.service('SessionStorageService', ['SessionTimeoutAction', SessionStorageService]);
export default SessionStorageService;
